module.exports = __webpack_public_path__ + "assets/img/5_1263.16bed722.jpg";